import { 
    ROUTER_ACTIVE_QOE_GRAPH_API_REQUEST,
    ROUTER_ACTIVE_QOE_GRAPH_API_SUCCESS
   } from "../../constants/graphConstants/connectedClientsGraphConstants";
  
export const routerActiveQOEGraphReducer = (
  state = { 
    routerActiveQoe: {
      routerHiSenseData:[],
      loading : false,
      yAxisLabels: [],
      apCount : [],
      qoeActive : [],
      routerParams: [],
      apiError: null,
    } 
  },
  action
) => {
  switch (action.type) {
    case ROUTER_ACTIVE_QOE_GRAPH_API_REQUEST:
      return {
          ...state,
          routerActiveQoe: {
            loading: action.payload,
            routerHiSenseData:[],
            yAxisLabels: [],
            apCount : [],
            qoeActive : [],
            routerParams :[],
            apiError: null,
          } 
      };
    case ROUTER_ACTIVE_QOE_GRAPH_API_SUCCESS:
      return {
        ...state,
        routerActiveQoe: {
            loading: false,
            ...action.payload
          } 
      };
    default:
      return state;
    }
}